import { Moon, Sun } from "@phosphor-icons/react";

import { useTheme } from "~/hooks/theme";
import { trackEvent } from "~/utils/analytics";

export const ColorModeToggle: React.FC = () => {
  const [theme, setTheme] = useTheme();
  return (
    <button
      onClick={() => {
        setTheme(theme !== "knoword" ? "knoword" : "dark");
        trackEvent("toggle_color_mode");
      }}
    >
      <span>{theme !== "knoword" ? "Light" : "Dark"} mode</span>
      <span />
      <div className="swap swap-rotate dark:swap-active">
        <Moon className="swap-on size-4" weight="bold" />
        <Sun className="swap-off size-4" weight="bold" />
      </div>
    </button>
  );
};
